import * as Sentry from '@sentry/react';
import mixpanel from 'mixpanel-browser';

const APP_HOSTS = ['app.sparklayer.io', 'app.dev.sparklayer.io'];
const MIXPANEL_TOKEN = 'ab795b7a2dc0a7dd5e60bc733715efb5';

export function initAnalytics(router: object) {
  if (!APP_HOSTS.includes(window.location.host)) {
    return;
  }

  Sentry.init({
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb?.data?.url?.includes('clarity.ms')) {
        return null;
      }
      return breadcrumb;
    },
    dsn: 'https://b2cd1b9778ed4f8abe25362246e2c35f@o932531.ingest.sentry.io/5881317',
    environment: window.location.host,
    ignoreErrors: [
      // Ignore network errors which are likely caused by user's unreliable network connection
      'error loading dynamically imported module',
      'Failed to fetch dynamically imported module',
      'Load failed',
      'NetworkError',
      'Network Error',
      'Unable to preload CSS',

      // https://stackoverflow.com/a/50387233
      'ResizeObserver loop limit exceeded',

      'ResizeObserver loop completed with undelivered notifications.',
      'Request failed with status code 401',
      'Request failed with status code 419',
    ],
    integrations: [
      Sentry.tanstackRouterBrowserTracingIntegration(router),
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: ['spark-dash'],
        behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
      }),
    ],
    // __SENTRY_RELEASE__ is statically replaced at build time by Vite
    // biome-ignore lint/correctness/noUndeclaredVariables: defined in build process
    release: __SENTRY_RELEASE__,
    tracesSampleRate: 0.1,
    sendDefaultPii: true,
  });

  mixpanel.init(MIXPANEL_TOKEN, { track_pageview: false });
}
